<template>
  <form-field :attribute="attribute" type="textarea" :label="label" :required="required" :errorKeys="errorKeys">
    <textarea @input="update" v-text="value"></textarea>
  </form-field>
</template>

<script>
import ActsAsFormField from "../../mixins/ActsAsFormField";
import ActsAsTextInput from "../../mixins/ActsAsTextInput";

export default {
  mixins: [ActsAsFormField, ActsAsTextInput],
};
</script>
